/*eslint-disable*/
import React from 'react'
import { Container, Segment, Button, Icon } from 'semantic-ui-react';
const OnClickTitleBar = (props) => {
    return (
        <>
            {
                props.approvals === true ? '' :
                    <div id="dispatch_bar">
                        <Container fluid className="m-0 p-0">
                            <Segment className="p-2">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="d-flex justify-content-between">
                                            <label className="mt-2 font-weight-normal">{props.title}</label>
                                            <div className="form-inline">
                                                {props.children}
                                                <Button onClick={props.newPopup} hidden={props.hiddenNew} size="tiny" basic color="blue" icon> <Icon name="plus" />New</Button>
                                                {/* <Link to={props.LinkName} hidden={props.hiddenNew} className="text-decoration-none w3-button w3-hover-border-black w3-hover-white w3-border-light-grey w3-small ml-1 w3-border w3-round"><i className="fas fa-plus"></i> New</Link> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Segment>
                        </Container>
                    </div>
            }
        </>
    )
}

export default OnClickTitleBar
